import { httpGet, httpPost, httpDelete } from "@/request/http";

let path = "/onlineorderitems";

export default {
  get(id) {
    return httpGet(`${path}/${id}`);
  },
  getPages(dTO) {
    return httpGet(`${path}/pages`, dTO);
  },
  post(item) {
    return httpPost(`${path}`, item);
  },
  postBatch(dTO) {
    return httpPost(`${path}/batch`, dTO);
  },
  remove(id) {
    return httpDelete(`${path}/${id}`);
  },
  getCategories(itemId) {
    return httpGet(`${path}/${itemId}/onlineordercategories`);
  },
  postCategories(itemId, dTO) {
    return httpPost(`${path}/${itemId}/onlineordercategories`, dTO);
  },
  getModifierGroups(itemId) {
    return httpGet(`${path}/${itemId}/onlineordermodifiergroups`);
  },
  postModifierGroups(itemId, dTO) {
    return httpPost(`${path}/${itemId}/onlineordermodifiergroups`, dTO);
  }
};
